module.exports = __webpack_public_path__ + "fonts/bold.ecc26e91.ttf";